import { getBaseUrl, getRoleTypeFromHeaders } from 'common/helpers/axios.helper';
import Logger from 'common/helpers/logger';
import { SOURCE_SERVICE } from 'common/const/config.const';
import { EImageSize, IMAGE_SIZE_LIST, TImageSizes } from 'entities/Image/Image.models';

export const getImageSize = (sizeFirst?: number | null, sizeSecond?: number | null) => {
  let size = sizeFirst;
  if (!sizeFirst || (sizeSecond && sizeFirst < sizeSecond)) {
    size = sizeSecond;
  }

  if (!size) {
    return null;
  }

  const sizeList = Object.keys(IMAGE_SIZE_LIST).sort((a, b) => Number(a) - Number(b));
  const key = sizeList.find(item => {
    if (Number(size) <= Number(item)) {
      return item;
    }
    return false;
  });

  if (key) {
    return IMAGE_SIZE_LIST[key as TImageSizes];
  }

  return null;
};

export const getImageUrl = (id?: string | null, size?: EImageSize | null, isPrivate?: boolean) => {
  if (id) {
    if (typeof id === 'string' && id !== 'undefined') {
      let link = isPrivate
        ? `${getBaseUrl()}/images/${id}?source=${SOURCE_SERVICE}`
        : `${getBaseUrl()}/images/${id}/public?source=${SOURCE_SERVICE}`;
      if (size) {
        link += `&size=${size}`;
      }
      return link;
    } else {
      Logger.err(['IMAGE', 'HELPER'], `Image id is not string [ROLE: ${getRoleTypeFromHeaders()}]`, JSON.stringify(id));
      return undefined;
    }
  }
  return undefined;
};
